module.exports = __webpack_public_path__ + "img/avatar3.00420b0d.png";